import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { cn } from "@omni/utils/styles";

import PageLink from "./PageLink/pageLink.component";

type Props = {
    links?: Array<PageLinkComponentProps>;
    spread?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    className?: string;
};

const PageLinks = ({ className, links = [], spread = 1 }: Props) => {
    return (
        <div className={cn("pl-component", className)}>
            {links.map(({ link, label }, index) => (
                <PageLink
                    link={link}
                    label={label}
                    spread={spread}
                    key={index}
                />
            ))}
        </div>
    );
};

export { PageLinks };
